import React from 'react';
import { useArticleWrapped } from '@hooks/useArticleWrapped';
import { Alert } from 'antd';
import styled from '@emotion/styled';

const StyledAlert = styled(Alert)`
  margin-bottom: 1rem;
`;

const StyledAlertDescription = styled.div`
  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const RegistrationInfoBox = ({ articleId }: { articleId: string }) => {
  const article = useArticleWrapped(articleId);

  if (!article) return null;

  return <StyledAlert message={<StyledAlertDescription dangerouslySetInnerHTML={{ __html: article.body }} />} />;
};
